/* lua.js generated code 0.3.0 */

var Event = require("cocos/framework/components/event")
require("cocos/cocos2d/Cocos2dConstants")

const BTN_MIN_SIZE = 60;    // 按键最小响应范围
const CLICK_CD = 200;       // 按键连点响应间隔

UIButton = xClass("UIButton", Event, function (node){
    return node;
})
UIButtonEvent = table(
    [1, "Down", "UIBUTTONEVENT.DOWN"],
    [1, "Up", "UIBUTTONEVENT.UP"],
    [1, "Move", "UIBUTTONEVENT.MOVE"],
    [1, "MoveIn", "UIBUTTONEVENT.MOVEIN"],
    [1, "MoveOut", "UIBUTTONEVENT.MOVEOUT"],
    [1, "Click", "UIBUTTONEVENT.CLICK"],
    [1, "Tap", "UIBUTTONEVENT.TAP"],
    [1, "UpOutside", "UIBUTTONEVENT.UPOUTSIDE"],
    [1, "LongPress", "UIBUTTONEVENT.LONGPRESS"]
)
UIButton.prototype.ctor = function (node, swallowTouch) {

    var self = this
    // init Node
    // cc.Node.prototype.ctor.call(self);
    self.bind(self)
    self.slideLimit = 20
    self.enabled = true
    self.enabledWithNotChange = true
    self.touchArea = null
    self.globalBoundingBox = null
    self.attachedIntersectFunction = null
    self.setTouchEvent(swallowTouch)

    self._inCD = false;
    self._resetCD = ()=> self._inCD = false;
    self.setEvents()

    self.hitTestPrior = false;  // 是否只判断本身的点击区域
}

UIButton.prototype.setEnabled = function (value) {
    var self = this
    self.enabled = value
}
UIButton.prototype.setEnabledWithNotChange = function (value) {
    var self = this
    self.enabledWithNotChange = value
}
UIButton.prototype.setTouchArea = function (rectInWorldSpace) {
    var self = this
    self.touchArea = rectInWorldSpace
}
UIButton.prototype.setText = function (text, offsetY) {
    let self = this
    let label = self.getChildByName("label")
    if (label) {
        label.setAnchorPoint(0.5, 0.5)
        label.setString(text)
        label.setPosition(0, offsetY || 0)
    }
}
UIButton.prototype.setTextOnly = function (text) {
    let self = this
    let label = self.getChildByName("label")
    if (label) {
        label.setString(text)
    }
}
UIButton.prototype.getText = function () {
    let self = this
    let label = self.getChildByName("label")
    if (label) {
        return label.getString();
    }
    return null;
}

UIButton.prototype.setTouchEvent = function (swallowTouch) {
    var self = this
    var [lastFrameInside, startPoint, tapDisabled] = [true, null, false]
    var listenner = cc.EventListenerTouchOneByOne.create()
    listenner.setSwallowTouches(swallowTouch || false)
    listenner.registerScriptHandler(function (touch, event) {
        if (!self.enabled || !self.enabledWithNotChange) {
            return false
        }

        var parent = self
        while (parent) {
            if (!parent.isVisible()) {
                return false
            }
            parent = parent.getParent()
        }
        var touchPos = touch.getLocation()
        if (self.touchArea && !cc.rectContainsPoint(self.touchArea, touchPos)) {
            return false
        }
        self.retain()
        let scene = cc.Director.getInstance().getRunningScene()
        let bound = self.hitTestPrior? he.HeDisplayUtil.getNodeBounds(self, scene): he.HeDisplayUtil.getNodeGroupBounds(self, scene, -100)
        let size = self.getContentSize()
        let p = {}
        p[1] = self.convertToWorldSpace(cc.p(0, 0))
        p[2] = self.convertToWorldSpace(cc.p(0, size.height))
        p[3] = self.convertToWorldSpace(cc.p(size.width, 0))
        p[4] = self.convertToWorldSpace(cc.p(size.width, size.height))
        let [minX, maxX, minY, maxY] = [p[1].x, p[1].x, p[1].y, p[1].y]
        for (let i = 1, v = p[1]; v; i++, v = p[i]) {
            minX = Math.min(minX, v.x)
            maxX = Math.max(maxX, v.x)
            minY = Math.min(minY, v.y)
            maxY = Math.max(maxY, v.y)
        }
        self.globalBoundingBox = cc.rect(bound.x, bound.y, Math.abs(maxX - minX), Math.abs(maxY - minY))
        if (self.globalBoundingBox.width < BTN_MIN_SIZE) {
            self.globalBoundingBox.x -= (BTN_MIN_SIZE - self.globalBoundingBox.width) / 2;
            self.globalBoundingBox.width += BTN_MIN_SIZE - self.globalBoundingBox.width
        }
        if (self.globalBoundingBox.height < BTN_MIN_SIZE) {
            self.globalBoundingBox.y -= (BTN_MIN_SIZE - self.globalBoundingBox.height) / 2;
            self.globalBoundingBox.height += BTN_MIN_SIZE - self.globalBoundingBox.height;
        }
        let intersect = cc.rectContainsPoint(self.globalBoundingBox, touchPos)
        if (intersect) {
            if (type(self.attachedIntersectFunction) === "function") {
                if (!self.attachedIntersectFunction(touchPos)) {
                    self.release()
                    return false
                }
            }
            self.dispatchEvent(table([1, "name", UIButtonEvent.Down], [1, "touchPos", touchPos]))
            lastFrameInside = true
            startPoint = touch.getLocation()
            tapDisabled = false
        }
        self.release()
        return intersect
    }, cc.Handler.EVENT_TOUCH_BEGAN)
    listenner.registerScriptHandler(function (touch, event) {
        if (!self.enabled || !self.globalBoundingBox) {
            return 
        }
        self.retain()
        var touchPos = touch.getLocation()
        var intersect = cc.rectContainsPoint(self.globalBoundingBox, touchPos)
        if (intersect) {
            if (!lastFrameInside) {
                self.dispatchEvent(table([1, "name", UIButtonEvent.MoveIn]))
            }
            self.dispatchEvent(table([1, "name", UIButtonEvent.Move], [1, "touchPos", touchPos]))
            lastFrameInside = true
        } else {
            if (lastFrameInside) {
                self.dispatchEvent(table([1, "name", UIButtonEvent.MoveOut], [1, "touchPos", touchPos]))
            }
            lastFrameInside = false
            tapDisabled = true
        }
        if (cc.pGetDistance(touch.getLocation(), startPoint) > self.slideLimit) {
            tapDisabled = true
        }
        self.release()
    }, cc.Handler.EVENT_TOUCH_MOVED)
    listenner.registerScriptHandler(function (touch, event) {
        if (!self.enabled || !self.globalBoundingBox) {
            return 
        }
        self.retain()
        var touchPos = touch.getLocation()
        var intersect = cc.rectContainsPoint(self.globalBoundingBox, touchPos)
        if (intersect) {            
            if (self._inCD)
                return;         
            self._inCD = true;
            setTimeout(self._resetCD, CLICK_CD);

            self.dispatchEvent({"name" : UIButtonEvent.Click, "touchPos": touchPos})
            // self.dispatchEvent(table([1, "name", UIButtonEvent.Click], [1, "touchPos", touchPos]))
            if (!tapDisabled && cc.pGetDistance(touch.getLocation(), startPoint) <= self.slideLimit) {
                // self.dispatchEvent(table([1, "name", UIButtonEvent.Tap], [1, "touchPos", touchPos]))
                self.dispatchEvent({"name" : UIButtonEvent.Tap, "touchPos": touchPos})
            }
        } else {
            // self.dispatchEvent(table([1, "name", UIButtonEvent.UpOutside], [1, "touchPos", touchPos]))
            self.dispatchEvent({"name" : UIButtonEvent.UpOutside, "touchPos": touchPos})
        }
        self.dispatchEvent({"name" : UIButtonEvent.Up, "touchPos": touchPos})
        self.release()
    }, cc.Handler.EVENT_TOUCH_ENDED)
    // TODO: event check
    // var eventDispatcher = self.getEventDispatcher()
    // eventDispatcher.addEventListenerWithSceneGraphPriority(listenner, self)
    self.listenner = listenner
    cc.eventManager.addListener(listenner, self)
    //cc.log("UIButton_listenner new:" + listenner.__instanceId)
}
UIButton.prototype.setSwallowTouches = function (swallowTouch) {
    let self = this
    self.listenner && self.listenner.setSwallowTouches(swallowTouch)
}
// UIButton.prototype.onEnter = function (value) {
//     cc.Node.prototype.onEnter.call(this)
// }
// UIButton.prototype.onExit = function (value) {
//     cc.Node.prototype.onExit.call(this)
// }
UIButton.prototype.cleanup = function () {
    this.removeAllEventListeners()
    cc.Node.prototype.cleanup.call(this)
}

UIButton.prototype.useSingleCall = function () {
    var self = this
    self.on(UIButtonEvent.Click, function () {
        if (self.singleCall) {
            self.singleCall()
        }
    })
}
UIButton.prototype.setSingleHandler = function (handler) {
    var self = this
    self.singleCall = handler
}
UIButton.prototype.setAttachedIntersectFunction = function (func) {
    let self = this
    self.attachedIntersectFunction = func
}

UIButton.prototype.showPrompt = function() {
    if (this._prompt != null) {
        this._prompt.setVisible(true);
        return;
    }

    let prompt = cc.Sprite.createWithSpriteFrameName("uilibrary/btn_prompt.png");
    this.addChild(prompt, 0, "prompt");
    let size = prompt.getContentSize();
    let bgSize = this.getContentSize();
    prompt.setPosition(bgSize.width / 2 * 0.85 + size.width * 0.15, bgSize.height / 2 * 0.7);
    prompt.setScale(0.7);
    this._prompt = prompt;
}

UIButton.prototype.clearPrompt = function() {
    if (this._prompt != null) {
        this._prompt.removeFromParent(true);
        this._prompt = null;
    }
}

/**
 * @param type 1看视频2分享
 */
UIButton.prototype.ttAddBtnFlag = function(type, dPos = cc.p(0, 0)){
    var flag = null;
    if (type == 1){
        flag = cc.Sprite.createWithSpriteFrameName("commonLib/lib_btn_video_flag.png");
    }else{
        flag = cc.Sprite.createWithSpriteFrameName("commonLib/lib_btn_share_flag.png");
    }
    this.addChild(flag, 0, "ttflag");
    DYAdUtil.hideVideoIcon(flag);
    let size = flag.getContentSize();
    let bgSize = this.getContentSize();
    flag.setPosition(cc.pAdd(cc.p(0-bgSize.width/2+size.width/2-6, 21), dPos));
}
UIButton.prototype.setEvents = function () {
    var self = this
    function playMusic() {
        var __VA_ARG = $slice(arguments, 0)
        // body
        // MusicPlayer.playEffect(GameMusicType.kBtnClick)
    }
    self.on(UIButtonEvent.Click, playMusic)
}